import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import style from '../../../common/orders/ordersStyle.module.css';
import CloseIcon from '@material-ui/icons/Close';
import commonStyles from '../../../common/common.module.css';
import trcCompanyModalStyles from './truckingCompanyModal.module.css';

import TruckDriverData from '../../../../models/TruckDriverData';

const TEXT_FIELD_PADDINGS: string = '8px 12px';

const styles = (theme: Theme) =>

  createStyles({
    submitBtn: {
      margin: '10px 20px'
    },
    textField45: {
      width: '100%'
    },
    gap20: {
      columnGap: '20px',
      flexWrap: 'wrap'
    },
    flexItem: {
      flex: '1 180px'
    }
  });

interface TruckingCompanyModalProps {
  classes: any;
  modalOpen: boolean;
  truckDriver: TruckDriverData;
  name: string;
  email:string;
  phoneNumber: string;
  isPhoneNumber: boolean;
  isEmail: boolean;
  isValidName: boolean;
  errorName: string;
  prefixPhoneNumber: string;
  handleCloseModal: () => void;
  handleChange: Function;
  handleSubmit: Function;
  onValidationName: any;
  onValidationEmail: any;
  company: string;
  onValidationPhoneNumber: any;
  isValidCompany: boolean;
  errorCompany: string;
  onValidationCompany: any;
};

const truckingCompanyModal = (props: TruckingCompanyModalProps) => {
  
  const { classes } = props;
  const phoneNumber: string = props.phoneNumber.replace('+1', '');
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ props.handleCloseModal }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'md' }
    >
      <DialogTitle id="form-dialog-title">
        <div className={ trcCompanyModalStyles.title }>
          <span>Create new Truck Driver</span>
          <IconButton aria-label="Close" onClick={ props.handleCloseModal }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div className={ commonStyles.wrapper }>

          <div className={ commonStyles.inputLabelWrapper }>
            <label className={ commonStyles.inputLabel }>Driver's Name*</label>
            <TextField
              className={ [classes.widthWrapper, classes.textField].join(' ') }
              variant="outlined"
              onChange={ (event) => props.handleChange('name', event) }
              onBlur={ props.onValidationName } 
              error={ !props.isValidName }
              value={ props.name }
              helperText={ !props.isValidName ? `${ props.errorName }` : '' }
              inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          <div className={ commonStyles.inputLabelWrapper }>
            <label className={ commonStyles.inputLabel }>Trucking Company *</label>
            <TextField
              className={ [classes.widthWrapper, classes.textField].join(' ') }
              variant="outlined"
              value={ props.company }
              onChange={ (event) => props.handleChange('company', event) }
              onBlur={ props.onValidationCompany } 
              error={ !props.isValidCompany }
              helperText={ !props.isValidCompany ? `${ props.errorCompany }` : '' }
              inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          <div className={ [style.flex, classes.widthWrappe, classes.gap20].join(' ') }>

            <div className={ `${ commonStyles.inputLabelWrapper } ${ classes.flexItem }` }>
              <label className={ commonStyles.inputLabel }>Driver's License</label>
              <TextField
                className={ [classes.textField45, classes.textField].join(' ')}
                variant="outlined"
                value={ props.truckDriver.license }
                onChange={ (event) => props.handleChange('license', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
            </div>

            <div className={ `${ commonStyles.inputLabelWrapper } ${ classes.flexItem }` }>
              <label className={ commonStyles.inputLabel }>Truck Plate</label>
              <TextField
                className={ [classes.textField45, classes.textField].join(' ') }
                variant="outlined"
                value={ props.truckDriver.plate }
                onChange={ (event) => props.handleChange('plate', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
            </div>
                
          </div>

          <div className={ [style.flex, classes.widthWrapper, classes.gap20].join(' ') }>

            <div className={ `${ commonStyles.inputLabelWrapper } ${ classes.flexItem }` }>
              <label className={ commonStyles.inputLabel }>Phone Number</label>
              <TextField
                className={ [classes.textField45, classes.textField].join(' ')}
                variant="outlined"
                InputProps={{
                  startAdornment: <InputAdornment position="start">{ props.prefixPhoneNumber }</InputAdornment>,
                  style: { padding: TEXT_FIELD_PADDINGS }
                }}
                value={ phoneNumber }
                onChange={ (event) => props.handleChange('phoneNumber', event) }
                onBlur={ props.onValidationPhoneNumber } 
                error={ !props.isPhoneNumber }
                helperText={ !props.isPhoneNumber ? 'Phone number must be at least ten digits long.' : '' }
                InputLabelProps={{ shrink: true }}
              />
            </div>
            
            <div className={ `${ commonStyles.inputLabelWrapper } ${ classes.flexItem }` }>
              <label className={ commonStyles.inputLabel }>Email</label>
              <TextField
                className={ [classes.textField45, classes.textField].join(' ') }
                variant="outlined"
                onChange={ (event) => props.handleChange('email', event) }
                onBlur={ props.onValidationEmail } 
                error={ !props.isEmail }
                value= { props.email }
                helperText={ !props.isEmail ? 'The email is not valid!' : '' }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
            </div>

          </div>

        </div>
      </DialogContent>
      <DialogActions>
        <Button 
          className={ classes.submitBtn }
          variant="contained" 
          color="primary" 
          disabled={ !props.isValidName || !props.isPhoneNumber || !props.isEmail || !props.name || !props.company }
          onClick={ () =>  props.handleSubmit() }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(truckingCompanyModal);